<script lang="ts">
    import type { PointsRewardEntity } from "@apps/rewards/entities/entities";
    import type RewardsAmountFormatter from "@apps/rewards/lib/RewardsAmountFormatter/RewardsAmountFormatter";
    import type { TranslationNamespaces } from "@apps/rewards/types";
    import type { GwI18n } from "@modules/i18n/GwI18n/GwI18n";

    import RewardsPoints from "../RewardsPoints.svelte";

    //Props
    export let reward: PointsRewardEntity;
    export let i18n: GwI18n;
    export let amountFormatter: RewardsAmountFormatter;
    export let pointsNamespace: TranslationNamespaces;
</script>

<RewardsPoints
    points={reward.points}
    {amountFormatter}
    {i18n}
    {pointsNamespace}
/>
